import selectedFiltersHtml from './selectedfilters.component.html';
import './selectedfilters.component.scss';

class SelectedFiltersController {
    constructor($scope, $window, SubmitOnChangeService, FullPageLoaderService) {
        'ngInject';
        this.$scope = $scope;
        this.$window = $window;
        this.service = SubmitOnChangeService;
        this.loaderService = FullPageLoaderService;
        this.buttons = [];

        $scope.$watch(
            () => this.service.forms.length,
            (newValue) => {
                if (!newValue) return;
                if (!newValue.length < 0) return;

                this.generateButtons(this.service.forms);
            }
        );
    }

    generateButtons(formsData) {
        const buttons = [];

        for (const formData of formsData) {
            const form = formData.form;

            if (form.hasAttribute('data-omit-buttons')) {
                continue;
            }

            if (formData.callback && formData.name) {
                buttons.push({
                    callback: formData.callback,
                    name: formData.name
                });
                continue;
            }

            const inputsMap = formData.inputs;

            if (inputsMap.size < 1) continue;

            for (const [input, value] of inputsMap) {
                if (!value) {
                    continue;
                }

                const name = input.labels[0].title || input.labels[0].innerText || input.labels[0].dataset.title;

                const button = {
                    callback: () => {
                        input.click();
                    },
                    name
                };

                buttons.push(button);
            }
        }

        this.buttons = buttons;
    }

    get resetUrl() {
        let pathname = this.$window.location.pathname.split('/');
        pathname.pop();
        pathname = pathname.join('/');

        return pathname;
    }

    removeAll() {
        this.$window.location.href = this.resetUrl;
        this.loaderService.show = true;
    }

    remove(button) {
        button.callback();
        this.buttons = this.buttons.filter(item => item !== button);
    }
}

let selectedFiltersComponent = {
    bindings: {},
    template: selectedFiltersHtml,
    controller: SelectedFiltersController
}

export default selectedFiltersComponent;
